import { useEffect, useState } from "react";
import Loader from "../../../../components/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import { CreateHandleUnsaveNavigation } from "../../../../utilities/handleUnsaveNavigation";
import * as yup from "yup";
import dayjs from "dayjs";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Dialog, DialogActions, Grid2, Typography } from "@mui/material";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import StyledGridComp from "../../../../components/StyledGridComp";
import ShipperManagement from "./ShipperManagement/ShipperManagement";
import {
  getDetaiSiteAcknowledgeDataService,
  getShipperDrugDataService,
  parseShipperRowService,
  postDetaileAcknowledgmentService,
} from "../../../../services/drugOrderManagementService";
import { DeleteOutlineOutlined } from "@mui/icons-material";
import {
  convertTimeString,
  notifyError,
  notifySuccess,
  notifyWarning,
} from "../../../../utilities/helper";
import ConfirmAcknowledge from "../AcknowledgeDrugOrder/ConfirmAcknowledge";

dayjs.extend(customParseFormat);

const ShipmentDrugOrder = () => {
  const id = useLocation()?.state?.id;
  const pluralKitAlias = localStorage?.getItem("pluralKitAlias");
  const roleId = localStorage.getItem("roleId");
  const access_token = localStorage?.getItem("access_token");

  const [load, setLoad] = useState(false);
  const [orderNumber, setOrderNumber] = useState("");
  const [orderDate, setOrderDate] = useState("");
  const [loadData, setLoadData] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [rowData, setRowData] = useState([]);
  const [rowLength, setRowLength] = useState(0);
  const [showShippers, setShowShippers] = useState(false);

  // Drug data related states
  const [drugData, setDrugData] = useState([]);
  const [unchangedDrugData, setUnchangedDrugData] = useState([]);
  const [actions, setActions] = useState([]);

  // Deletion related states
  const [deletedId, setDeletedId] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [showConfirmPage, setShowConfirmPage] = useState(false);
  const [acknowledgeConfirmData, setAcknowledgeConfirmData] = useState(null);

  const handleUnsaveNavigation = CreateHandleUnsaveNavigation();
  const navigate = useNavigate();

  const createShipmentSchema = yup.object().shape({
    acknowledgementDate: yup
      .mixed()
      .test("is-valid-date", "Acknowledgment date is required", (value) =>
        dayjs(value).isValid()
      )
      .nullable(),
  });

  const {
    handleSubmit,
    control,
    reset,
    formState: { isDirty, errors },
  } = useForm({
    resolver: yupResolver(createShipmentSchema),
    defaultValues: {
      acknowledgementDate: "",
    },
  });

  useEffect(() => {
    if (access_token && id) {
      getAcknowledgementDataOnLoad(id);
    }
  }, [access_token, id]);

  useEffect(() => {
    if (id) {
      getDrugData(id);
    }
  }, [id]);

  const columns = [
    {
      field: "tempMonitorId",
      headerName: "Temperature Monitor ID",
      width: 250,
      renderHeader: () => (
        <div className="grid-heading">{"Temperature Monitor ID"}</div>
      ),
      renderCell: (params) => {
        const tempMonitorId = params.row.tempMonitorId;

        return <span className="data-font">{tempMonitorId}</span>;
      },
    },
    {
      field: "maxTemperature",
      headerName: "Max Temperature",
      width: 250,
      renderHeader: () => (
        <div className="grid-heading">{"Max Temperature"}</div>
      ),
      renderCell: (params) => {
        const maxTemperature = params.row.maxTemperature;

        return <span className="data-font">{maxTemperature}</span>;
      },
    },
    {
      field: "minTemperature",
      headerName: "Min Temperature",
      width: 250,
      renderHeader: () => (
        <div className="grid-heading">{"Min Temperature"}</div>
      ),
      renderCell: (params) => {
        const minTemperature = params.row.minTemperature;

        return <span className="data-font">{minTemperature}</span>;
      },
    },
    {
      field: "timeBelowMin",
      headerName: "Time Below Min Temperature",
      width: 250,
      renderHeader: () => (
        <div className="grid-heading">{"Time Below Min Temperature"}</div>
      ),
      renderCell: (params) => {
        const timeBelowMin = params.row.timeBelowMin;

        return <span className="data-font">{timeBelowMin}</span>;
      },
    },
    {
      field: "timeAboveMax",
      headerName: "Time Above Max Temperature",
      width: 250,
      renderHeader: () => (
        <div className="grid-heading">{"Time Above Max Temperature"}</div>
      ),
      renderCell: (params) => {
        const timeAboveMax = params.row.timeAboveMax;

        return <span className="data-font">{timeAboveMax}</span>;
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 280,
      renderHeader: () => <div className="grid-heading">{"Action"}</div>,
      renderCell: (params) => {
        const id = params.row.id;

        return (
          <div
            style={{
              margin: "auto",
              marginTop:"5px"
            }}
          >
            <button
              className="grid-edit-btn"
              style={{ background: "red" }}
              onClick={() => {
                setShowConfirmModal(true);
                setDeletedId(id);
              }}
            >
              <DeleteOutlineOutlined sx={{ color: "white" }} />
            </button>
          </div>
        );
      },
    },
    ,
  ];

  const getAcknowledgementDataOnLoad = async (orderId) => {
    try {
      setLoad(true);
      const res = await getDetaiSiteAcknowledgeDataService(
        access_token,
        orderId
      );
      if (
        res?.status == 200 &&
        res?.data?.message == "Data Extracted for detailed Ack Onload!"
      ) {
        setLoad(false);
        setLoadData(res?.data?.result);
        setOrderNumber(res?.data?.result?.orderNumber);
        setOrderDate(res?.data?.result?.orderDate);
      }
    } catch (err) {
      setLoad(false);
      console.log("Error occurred", err?.message);
      if (err?.status == 401) {
        navigate("/unAuthorize");
      }
    }
  };

  const getDrugData = async (orderId, alreadyAssignedJson = []) => {
    try {
      setLoad(true);
      const res = await getShipperDrugDataService(
        access_token,
        orderId,
        alreadyAssignedJson
      );
      if (res?.status == 200) {
        setLoad(false);
        let temp = [];

        const drugs = res?.data?.result?.drugs || [];
        const patientVisitDrugs =
          res?.data?.result?.drugReturnConfig?.patientVisitDrugs || [];

        // Build a lookup map for patientVisitDrugs by drugId
        const visitDrugMap = new Map(
          patientVisitDrugs.map((ele) => [ele?.drugId, ele])
        );

        // Iterate drugs only once
        drugs.forEach((item) => {
          const ele = visitDrugMap.get(item?.drugId);
          if (ele) {
            let dataObj = ele?.drug?.drugType;
            let obj = {
              triggerTemperatureMax: dataObj?.triggerTemperatureMax,
              triggerTemperatureMin: dataObj?.triggerTemperatureMin,
              packingType: dataObj?.package?.name,
              maxReturnablePillCount: dataObj?.maxReturnablePillCount,
              pillCount: ele?.pillCount,
            };
            temp.push({ ...item, ...obj });
          }
        });
        setDrugData(temp);
        setUnchangedDrugData(temp);
        setActions(res?.data?.result?.allowedStatus);
      }
    } catch (err) {
      setLoad(false);
      console.log("Error", err?.message);
      if (err?.status == 401) {
        navigate("/unAuthorize");
      }
    }
  };

  const submitShipmentAcknowledgment = async (data) => {
    const newShipperData = await getShipperData(rowData);
    let shippingJSON = buildDrugArray(
      rowData,
      unchangedDrugData,
      newShipperData
    );
    const payload = {
      id: loadData?.id,
      hasAlarm: loadData?.hasAlarm,
      orderDateTimeOffset: loadData?.orderDateTimeOffset,
      receivedDate: dayjs(
        data.acknowledgementDate,
        "DD-MMM-YYYY"
      ).toISOString(),
      destinationDepotId: "",
      destinationTimeZone: loadData?.destinationTimeZone,
      applyDrugStatus: loadData?.applyDrugStatus,
      destinationSiteId: loadData?.destinationSiteId,
      shippers: newShipperData || [],
      shipperMappingsJson: JSON.stringify(shippingJSON),
    };
    try {
      setLoad(true);
      const res = await postDetaileAcknowledgmentService(
        access_token,
        pluralKitAlias,
        payload,
        roleId
      );
      if (res?.data?.status === "Failed") {
        setLoad(false);
        notifyWarning(res?.data?.message);
      } else if (res?.data?.status == "201OK") {
        setLoad(false);
        notifySuccess(res?.data?.message);
        setAcknowledgeConfirmData(res?.data?.result);
        setRowData([]);
        setShowConfirmPage(true);
        reset();
      } else if (res.status == 400) {
        setLoad(false);
        notifyError("Error occurred.");
      }
    } catch (err) {
      console.log("Error:", err?.message);
      setLoad(false);
      notifyError(err?.message);
      if (err?.status == "401") {
        navigate("/unAuthorize");
      }
    }
  };

  const getShipperData = async (rowData) => {
    try {
      let payload = rowData?.map((item) => {
        return {
          id: loadData?.id,
          minTemperature: item?.minTemperature,
          maxTemperature: item?.maxTemperature,
          temperatureMonitorId: item?.tempMonitorId,
          timeAboveMaxTemperatureStr: item?.timeAboveMax?.includes("d")
            ? item?.timeAboveMax
            : convertTimeString(item?.timeAboveMax),
          timeBelowMinTemperatureStr: item?.timeBelowMin?.includes("d")
            ? item?.timeBelowMin
            : convertTimeString(item?.timeBelowMin),
          shipperDrugs: "",
          missingDrugs: "",
          damagedDrugs: "",
          timeAboveMaxTemperature: 0,
          timeBelowMinTemperature: 0,
        };
      });
      const res = await parseShipperRowService(access_token, payload);
      return res?.data?.result;
    } catch (err) {
      console.log(err);
      if (err?.status == 401) {
        navigate("unAuthorize");
      }
    }
  };

  function buildDrugArray(array1, array2, shipperArray) {
    const result = [];
    const added = new Set(); // prevent duplicates

    // Build lookup for shipperArray by temperatureMonitorId
    const shipperMap = new Map(
      shipperArray?.map((item) => [item?.temperatureMonitorId, item?.id])
    );

    array2.forEach((drug) => {
      let shipperId = null;
      let tempMonitorId = null;

      // Find shipperId and tempMonitorId from array1
      for (const item1 of array1) {
        if (item1.assignedJson && drug.drugId in item1.assignedJson) {
          shipperId = item1.assignedJson[drug.drugId];
          tempMonitorId = item1.tempMonitorId;
          break; // stop once found
        }
      }

      if (shipperId && tempMonitorId) {
        // Now match using tempMonitorId against shipperArray
        const matchingShipperId = shipperMap.get(tempMonitorId);

        const uniqueKey = `${drug.drugId}-${shipperId}-${matchingShipperId}`;

        if (!added.has(uniqueKey)) {
          result.push({
            drugId: drug.drugId,
            statusId: shipperId, // from assignedJson
            shipperId: matchingShipperId || "", // from shipperArray
            drugTypeId: drug.drugTypeId,
          });
          added.add(uniqueKey);
        }
      }
    });

    return result;
  }

  const handleDelete = () => {
    const deletedRow = rowData?.find((item) => item?.id === deletedId);
    const filterData = rowData.filter((item) => item?.id !== deletedId);

    setRowData(filterData);

    // this is for re-adding the added drugs to the drug table
    if (deletedRow?.assignedJson) {
      const recoveredRows = Object.keys(deletedRow.assignedJson)
        .map((key) => unchangedDrugData.find((ele) => ele?.drugId === key))
        .filter(Boolean); // remove null/undefined

      setDrugData((prev) => {
        const existingIds = new Set(prev.map((item) => item.drugId));
        const newRows = recoveredRows.filter(
          (row) => !existingIds.has(row.drugId)
        );
        return [...prev, ...newRows];
      });
    }

    setDeletedId(null);
    setShowConfirmModal(false);
  };

  return (
    <>
      {showConfirmPage ? (
        <ConfirmAcknowledge
          data={acknowledgeConfirmData}
          setShowConfirm={setShowConfirmPage}
        />
      ) : (
        <>
          {showShippers ? (
            <ShipperManagement
              setShowShippers={setShowShippers}
              setRowData={setRowData}
              orderNumber={orderNumber}
              actions={actions}
              drugData={drugData}
              setDrugData={setDrugData}
            />
          ) : (
            <>
              {load ? (
                <Loader />
              ) : (
                <div className="content-body">
                  <p className="bread-crumbs-link-container">
                    <button
                      className="bread-crumbs-btn"
                      onClick={(e) =>
                        handleUnsaveNavigation(e, isDirty, "", navigate)
                      }
                    >
                      Home
                    </button>{" "}
                    |{" "}
                    <button
                      className="bread-crumbs-btn"
                      onClick={(e) =>
                        handleUnsaveNavigation(
                          e,
                          isDirty,
                          "drug-shipment-management",
                          navigate
                        )
                      }
                    >
                      Drug Order Management
                    </button>{" "}
                    |{" "}
                    <button className="bread-crumbs-btn">
                      Acknowledge Shipment Order{" "}
                    </button>
                    -{" "}
                    <b style={{ color: "gray" }}>
                      {localStorage?.getItem("studyName")}
                    </b>
                  </p>

                  <Grid2
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ width: "100%", margin: "0 auto" }}
                  >
                    <Grid2 item md={4}>
                      <p className="page-heading">Site Acknowledge Shipment</p>
                    </Grid2>
                  </Grid2>

                  <div>
                    <div
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        margin: "20px auto",
                        textAlign: "center",
                      }}
                    >
                      Order Number{" "}
                      <span
                        style={{
                          color: "gray",
                        }}
                      >
                        #{orderNumber}
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        margin: "20px auto",
                        textAlign: "center",
                      }}
                    >
                      Order Date{" "}
                      <span
                        style={{
                          color: "gray",
                        }}
                      >
                        {orderDate}
                      </span>
                    </div>
                    <Box
                      component="form"
                      autoComplete="off"
                      sx={{
                        height: "auto",
                      }}
                      onSubmit={handleSubmit(submitShipmentAcknowledgment)}
                    >
                      <Grid2
                        container
                        alignItems="center"
                        justifyContent={"space-between"}
                        sx={{ width: "50%", margin: "0 auto" }}
                        gap={1}
                      >
                        <Grid2
                          size={{ xl: 12, md: 12, lg: 12, sm: 12, xs: 12 }}
                        >
                          <div>
                            <p className="labelStyles">
                              Acknowledgment Date
                              <span>*</span>
                            </p>
                          </div>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Controller
                              name="acknowledgementDate"
                              control={control}
                              rules={{
                                required: "Acknowledgment date is required",
                              }} // Optional validation rule
                              render={({ field }) => (
                                <DatePicker
                                  sx={{ width: "100%" }}
                                  value={
                                    field.value ? dayjs(field.value) : null
                                  }
                                  onChange={(date) =>
                                    field.onChange(
                                      date
                                        ? dayjs(date).format("DD-MMM-YYYY")
                                        : null
                                    )
                                  }
                                  shouldDisableDate={(date) => {
                                    if (!orderDate) return false;

                                    const minDate = dayjs(
                                      orderDate,
                                      "DD-MMM-YYYY"
                                    );
                                    const maxDate = dayjs(); // today

                                    // disable if before orderDate OR after today
                                    return (
                                      date.isBefore(minDate, "day") ||
                                      date.isAfter(maxDate, "day")
                                    );
                                  }}
                                  format="DD-MMM-YYYY"
                                  slotProps={{
                                    textField: {
                                      placeholder: "DD-MMM-YYYY",
                                      sx: {
                                        "& .MuiInputBase-root": {
                                          height: "40px",
                                        },
                                      },
                                      size: "small",
                                      fullWidth: true,
                                    },
                                  }}
                                />
                              )}
                            />
                          </LocalizationProvider>
                          {errors.acknowledgementDate && (
                            <div className="error-container">
                              {errors.acknowledgementDate.message}
                            </div>
                          )}
                        </Grid2>
                      </Grid2>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "start",
                        }}
                      >
                        <button
                          type="button"
                          className="create-btn-outlined"
                          onClick={() => setShowShippers(true)}
                        >
                          + Add Shippers
                        </button>
                      </div>

                      <div
                        style={{
                          margin: "40px 0px",
                        }}
                      >
                        <StyledGridComp
                          rows={rowData}
                          columns={columns}
                          page={page}
                          setPage={setPage}
                          pageSize={pageSize}
                          setPageSize={setPageSize}
                          length={rowLength}
                          isPaginationClientSide={true}
                        ></StyledGridComp>
                      </div>

                      <Grid2
                        alignItems={"end"}
                        justifyContent="end"
                        container
                        gap={3}
                        sx={{ marginTop: "2%" }}
                      >
                        <Grid2 item md={6}>
                          <button
                            type="button"
                            className="create-btn-outlined"
                            onClick={(e) => {
                              e.preventDefault();
                              handleUnsaveNavigation(
                                e,
                                isDirty,
                                "drug-shipment-management",
                                navigate
                              );
                            }}
                          >
                            Cancel
                          </button>
                        </Grid2>
                        <Grid2 item md={6}>
                          <button type="submit" className="create-btn">
                            Save
                          </button>
                        </Grid2>
                      </Grid2>
                    </Box>
                  </div>
                </div>
              )}
            </>
          )}

          {showConfirmModal && (
            <Dialog
              open={showConfirmModal}
              onClose={() => setShowConfirmModal(false)}
            >
              <div
                style={{
                  width: "400px",
                  padding: "20px",
                }}
              >
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Delete Shipper Detail
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Are you sure you want to delete this detail ?
                </Typography>
              </div>
              <DialogActions>
                <button
                  className="create-btn"
                  style={{ width: "120px" }}
                  onClick={handleDelete}
                >
                  Yes
                </button>
                <button
                  className="create-btn-outlined"
                  style={{ width: "120px" }}
                  onClick={() => setShowConfirmModal(false)}
                >
                  No
                </button>
              </DialogActions>
            </Dialog>
          )}
        </>
      )}
    </>
  );
};

export default ShipmentDrugOrder;
